<template>

  <el-container class="container-dashboard" style="height: 100%;">
    <el-aside width="280px">
      <el-container style="height: 100%;" direction="vertical">
        <div class="search">
          <el-input v-model="keyword" class="btn-search" maxlength="20" placeholder="通过名字搜索" @keyup.enter.native="handleSeach">
            <i slot="suffix" class="el-input__icon icon-search" @click="handleSeach" />
          </el-input>
        </div>
        <el-main class="aside-main">
          <el-tree
            v-if="refresh"
            ref="depTree"
            v-loading="depLoading"
            class="tree-dep"
            :data="departments"
            :props="treeProps"
            node-key="id"
            accordion
            :default-expand-all="true"
            check-on-click-node
            highlight-current
            @node-click="handleDepClick"
          />
        </el-main>
      </el-container>
    </el-aside>
    <el-container class="container-main">
      <el-main class="main-container">
        <el-container class="container-table" style="height: 100%">
          <el-header
            height="48px"
            style="display: flex; justify-content:space-between"
          >
            <span class="header-title">万孚生物<i>{{ totalPeople }}人</i></span>
            <!-- <el-pagination
              background
              layout="prev, slot, next"
              :total="total"
              :page-size.sync="listQuery.limit"
              :current-page.sync="listQuery.page"
              @current-change="handlePagination"
            >
              <span>{{ listQuery.page }}/{{ totalPage }}</span>
            </el-pagination> -->
            <!-- <el-button type="primary" :disabled="multipleUsers.length===0?true:false"
            style="border-radius: 25px; margin:5px 0; line-height: 0px;"
            @click="goRoleEdit()"
            round>批量分配</el-button> -->
          </el-header>
          <el-main>
            <el-table
              ref="multipleTable"
              v-loading="depUsersLoading"
              :data="depUsers"
            >
              <el-table-column label="员工">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column label="职位" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="bottom-end">
                    <div>{{ scope.row.position }}</div>
                    <div slot="reference" class="tooltip-label">
                      {{ scope.row.position }}
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="部门" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="bottom-end">
                    <span>{{ scope.row.department | departmentFormat }}</span>
                    <div slot="reference" class="tooltip-label">
                      {{ scope.row.department | departmentFormat }}
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="手机" min-width="120">
                <template slot-scope="scope">
                  {{ scope.row.mobile }}
                </template>
              </el-table-column>
              <el-table-column label="E-mail" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="bottom-end">
                    <span>{{ scope.row.email }}</span>
                    <div slot="reference" class="tooltip-label">
                      {{ scope.row.email }}
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="业务权限">
                <template slot-scope="scope">
                  <!-- <el-popover trigger="hover" placement="bottom-end"> -->
                    <!-- <div v-for="(auth,index) in authDeal(scope.row.buzAuth)" :key="index">{{ auth }}</div> -->
                    <div slot="reference" class="tooltip-label">
                      {{ scope.row.role && scope.row.role.length || "0" }}个角色
                    </div>
                  <!-- </el-popover> -->
                </template>
              </el-table-column>
              <el-table-column label="数据权限">
                <template slot-scope="scope">
                  <!-- <el-popover trigger="hover" placement="bottom-end">
                    <div v-for="(dataAuth,index) in dataAuthDeal(scope.row.dataAuth)" :key="index" class="">{{ dataAuth }}</div> -->
                    <!-- <div slot="reference" class="tooltip-label"> -->
                      {{ scope.row.dataAuth | dataAuthFormat }}
                    <!-- </div> -->
                  <!-- </el-popover> -->
                </template>
              </el-table-column>
              <el-table-column label="最后授权人">
                <template slot-scope="scope">
                  {{ scope.row.authorizer }}
                </template>
              </el-table-column>
              <el-table-column label="最后授权时间">
                <template slot-scope="scope">
                  {{ scope.row.authorizeTime | dateFormatAuth(2) }}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <!-- <el-button :disabled="checkboxF(scope.row)" @click="goRoleEdit(scope.row)" type="text" size="small">
                    分配权限
                  </el-button> -->
                  <el-button @click="goRoleEdit(scope.row)" type="text" size="small"
                  :disabled="isJuris(scope.row)">
                    分配权限
                  </el-button>                  
                </template>
              </el-table-column>              
            </el-table>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getDepartments, getDepUsers, getDepAuth, userAuthorize, userAuthorizeReset } from '@/api/manage'
import { departmentFormat, dataAuthFormat, authFilter, dataAuthFilter, getTreeArrayByValue2, dateFormatAuth } from '@/utils/filter'
import code from '@/utils/code'
import _ from 'lodash'

export default {
  name: 'Auth',
  filters: { departmentFormat, dataAuthFormat, authFilter, dataAuthFilter, dateFormatAuth },
  data() {
    return {
      info: null,

      depUsers: null,
      departments: null,
      totalPeople: 0,
      depLoading: true,
      depSelected: null,
      refresh: true,
      keyword: null,
      listQuery: {
        id: null,
        name: null
      },
      total: 0,
      totalPage: 1,
      depUsersLoading: false,
      userSelected: [], // 批量选择的员工
      treeProps: {
        children: 'child',
        label: 'name'
      },
      platforms: [],
      authRange: null,
      authRangeLoading: false,
      region: [],
      regions: null,
      //regionSelecteds: null,  // 被选择的平台，区域
      regionsRefer: null,
      regionsReferSelected: null,
      multipleUsers: [],
      basedata: JSON.parse(sessionStorage.getItem('base')),// 基础数据
    }
  },
  created() {
    this.getDeps()
    this.info = JSON.parse(sessionStorage.getItem('info'))
    //this.info.isSuper = 0
    console.log(this.info)
    this.getDepAuth()
    this.setData()
  },
  activated () {
    console.log('activated')
    this.getDepUsers()
  },
  methods: {
    setData() {
      //this.authListDeal(new Map(JSON.parse(sessionStorage.getItem('authMap'))))
      this.info = JSON.parse(sessionStorage.getItem('info'))
      this.platforms = this.info.dataAuth
      this.regions = new Map()
      //this.regionSelecteds = new Map()
      this.regionsRefer = new Map()
      console.log(this.info)
      console.log(this.platforms)
      this.platforms && this.platforms.forEach(e => {
        const r = this.dealDataAuth(JSON.parse(JSON.stringify(code)), e.region)
        this.regions.set(e.platformId, r)
        this.regionsRefer.set(e.platformId, JSON.parse(JSON.stringify(r)))
      })
      console.log(this.regions)
      
      this.region = this.regions.get(this.platforms[0].platformId)
      this.regionsReferSelected = this.regionsRefer.get(this.platforms[0].platformId)
      console.log(this.regionsRefer)

      // 开发模拟info配置
      // this.info.isSuper = 0
      // this.info.role = [1,2,3,4,5]
      // this.info.dataAuth = [
      //   {
      //     platformId: 1,
      //     platformName: "化学发光",
      //     region: [{regionId: "86", regionType: 0}]
      //   },
      //   {
      //     platformId: 4,
      //     platformName: "荧光",
      //     region: [{regionId: "86", regionType: 0}]
      //   }
      // ]
      // // 超管处理
      if(this.info.isSuper == 1) {
        this.region[0].disabled = true
      }
      console.log(this.region)
    },
    getDeps() {
      this.depLoading = true
      getDepartments().then(response => {
        this.departments = [response.data]
        this.totalPeople = response.totalPeople
        this.depLoading = false
      })
    },
    getDepAuth() {
      //this.authRangeLoading = true
      //const ids = this.info.rangeAuth
      // getDepAuth({ ids }).then(response => {
      //   this.authRange = this.dealAuthRange([response.data])
      //   //this.authRangeLoading = false
      // })
    },

    // 搜索用户
    getDepUsers() {
      if(sessionStorage.getItem('nowUserListQue')) {
        this.listQuery = JSON.parse(sessionStorage.getItem('nowUserListQue'))
        sessionStorage.removeItem('nowUserListQue')
      }
      this.depUsersLoading = true
      this.depUsers = []
      getDepUsers(this.listQuery).then(response => {
        this.depUsers = response.data
        if (response.total && response.total >= 0) {
          this.total = response.total
          this.totalPage = Math.ceil(response.total / this.listQuery.limit)
        }
        this.depUsersLoading = false
      })
      
    },
    handleSeach: _.throttle(function() {
      this.listQuery.page = 1
      this.listQuery.id = null
      this.listQuery.name = this.keyword
      this.getDepUsers()
      this.refresh = false
      this.$nextTick(() => {
        this.refresh = true
      })
    }, 1000, { 'trailing': false }),
    handleDepClick(data, node, VueComponent) {
      if (this.listQuery.id !== data.id) {
        this.total = 0
        this.totalPage = 1
        this.listQuery.page = 1
        this.listQuery.name = null
        this.listQuery.id = data.id
        this.getDepUsers()
      }
    },
    dealDataAuth(code, region) {
      let regionArrayAll = []
      const regionArray = []
      region && region.forEach(e => {
        const www = getTreeArrayByValue2('value', e.regionType + '-' + e.regionId, 'children', code, 'value')
        regionArrayAll = regionArrayAll.concat(www)
        regionArray.push(e.regionType + '-' + e.regionId)
      })

      const result = []
      let tem
      function each(data, myArray) {
        let aaa = true
        data.map(function(v, k, arr) {
          let tag = true
          if (regionArrayAll.indexOf(v.level + '-' + v.value) > -1) {
            aaa = false
            const bbb = JSON.parse(JSON.stringify(v))
            tem = JSON.parse(JSON.stringify(bbb.children))
            bbb.children = []
            if (regionArray.indexOf(v.level + '-' + v.value) === -1) {
              bbb.disabled = true
            }
            myArray.push(bbb)
          } else {
            tag = false
          }
          if (k === (arr.length - 1) && aaa) {
            // console.log(1111)
            tem && tem.forEach(e => {
              myArray.push(e)
            })
          }
          if (tag && v.children && v.children.length > 0) {
            // console.log(v)
            // console.log(myArray[myArray.length - 1])
            each(v.children, myArray[myArray.length - 1].children)
          }
        })
      }
      each(code, result)
      return result
    },
    // 进入权限分配页面
    goRoleEdit(value) {
      sessionStorage.setItem('nowUserListQue', JSON.stringify(this.listQuery))
      this.$router.push({ name: 'authEdit' })
      
      window.localStorage.setItem('userSelected', JSON.stringify(value))
      console.log(value)
    },
    // 是否可以分配权限
    isJuris(row) {
      if(row) {
        if(row.role) {
          if(row.isSuper == 1 || (row.role.indexOf(1)>-1 && this.info.role.indexOf(1)>-1 && this.info.isSuper == 0)) {
            return true
          }
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.container-dashboard {
  font-size: 14px;
  color: #222222;
  input:focus { outline:none }
  .el-main {
    padding: 0;
  }
  .btn-submit {
    background-color: #4A90E2;
    border-radius:4px;
    padding: 9px 35px;
  }
  .btn-reset {
    position: absolute;
    right: 14px;
    bottom: 14px;
    background-color: #4A90E2;
    border-radius:4px;
    padding: 9px 35px;
  }
  .search {
    padding: 14px;
    border-bottom: 1px solid #D8D8D8;
    .icon-search {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin: 7px;
      background: url("../../assets/search.png");
      background-size: contain;
    }
  }
  .el-header {
    overflow: hidden;
  }
  .aside-main {
    .tree-dep {
      margin-top: 14px;
    }
  }
  .container-main{
    background-color: #F1F4F7;
    .main-container {
      background-color: #fff;
      margin: 14px;
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
      border-radius:4px;
      // padding-bottom: 62px;
      position: relative;
      .container-table {
        .el-header {
          padding: 0 14px;
          border-bottom: 1px solid #D8D8D8;
          .header-title {
            display: inline-block;
            height: 48px;
            line-height: 48px;
            font-size: 16px;
            i {
              font-size: 14px;
              color: #91A0AF;
              font-style: normal;
              margin-left: 10px;
            }
          }
          .el-pagination {
            float: right;
          }
        }
        .el-main {
          margin: 14px;
          //padding-bottom: 14px;
          border-bottom: 1px solid #D8D8D8;
          .el-table {
            .tooltip-label {
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
  .container-auth {
    // display: block;
    .el-header {
      background-color: #F1F4F7;
      line-height: 34px;
      padding-left: 10px;
    }
    >.el-container {
      border: 1px solid #F1F4F7;
    }


    .container-left {
      // height: 280px;
      margin: 0 14px;
      flex: 1;
      .radio-style {
        width: 145px;
        padding: 5px 15px;
        border: 1px;
      }
      .el-button--primary{
        background-color: #4A90E2;
      }
      .el-main {
        padding: 10px;
        .el-header {
          line-height: 30px;
        }
        .left-main-con {
          >.el-container {
            margin-right: 10px;
            border: 1px solid #F1F4F7;
            &:last-child {
              margin-right: 0;
            }
            &:nth-child(1) {
              /*角色固定宽度*/
              flex: 0 0 200px;
            }
            .el-checkbox {
              display: block;
              margin-bottom: 16px;
            }
          }
        }
      }
    }
    .container-right {
      // height: 280px;
      margin: 0 14px 0;
      flex: 1;
      .radio-style {
        width: auto;
        padding: 5px 15px;
        border: 1px;
        margin-right: 15px; 
      }
      .el-button--primary{
        background-color: #4A90E2;
      }
      .el-main {
        padding: 10px;
        .el-header {
          line-height: 30px;
        }
        .right-main-con {
          >.el-container {
            margin-right: 10px;
            border: 1px solid #F1F4F7;
            &:last-child {
              margin-right: 0;
            }
            &:nth-child(1) {
              /*固定宽度*/
              flex: 0 0 150px;
            }
            .el-checkbox {
              display: block;
              margin-bottom: 16px;
              margin-right: 30px;
            }
          }
        }
      }
    }
  }
  .member{
    display: flex;
    align-items: center;
    margin: 0 0 10px 20px;
    p{
      margin: 0;
    }
    .memberSelect{
      border: 2px solid #F1F4F7;
      border-radius: 5px;
      padding: 5px;
      margin: 0 0 0 20px;
    }
  }
}
  // /deep/ .el-checkbox-button__original{
  //     border-radius: 12px;
  // }
</style>
<style lang="scss">
.container-dashboard {
  .el-input__inner {
    height: 34px;
  }
  .el-input__suffix {
    right: 0;
    cursor: pointer;
  }
  .el-input__inner:focus {
    border-color: #DCDFE6;
  }
  .el-input__suffix-inner {
    display: inline-block;
    width: 34px;
    height: 34px;
    background: #E6EBF0;
    border-radius: 0 4px 4px 0;
  }
  .el-tree-node__content {
    height: 34px;
    position: relative;
  }
  .aside-main {
    .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
      background-color: #4A90E2;
      color: #fff;
    }
    .tree-selected {
      background-color: #4A90E2;
      color: #fff;
    }
    .el-tree-node__content:hover {
      background-color: #fff;
    }
    .el-tree-node:focus>.el-tree-node__content:hover {
      background-color: #4A90E2;
      color: #fff;
    }
  }
  .el-tree-node>.el-tree-node__children {
    overflow: visible;
  }
  .left-main-con {
    .el-tree-node:focus>.el-tree-node__content, .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
      background-color: #fff;
    }
    .el-tree-node__content:hover {
      background-color: #fff !important;
    }
  }
  .el-tree, .el-pagination span, .el-table, .el-checkbox, .el-cascader-menu {
    color: #222222;
  }
  .el-header {
    padding: 0;
  }
  .el-pagination {
    font-weight: 400;
    padding: 0;
    margin-top: 10px;
    .btn-prev, .btn-next {
      min-width: 28px;
    }
    .btn-next {
      margin-right: 0;
    }
  }
  .el-table td, .el-table th.is-leaf {
    border: none;
  }
  .el-table--border::after, .el-table--group::after, .el-table::before {
    background-color: #fff;
  }
  .el-table .cell {
    line-height: 24px;
  }
  .el-table th {
    padding: 8px 0;
  }
  .el-table td {
    padding: 6px 0;
  }
  .el-table th {
    background-color: #F1F4F7;
  }
  .el-table thead {
    color: #646E78;
  }
  .el-radio-button__inner, .el-radio-button:first-child .el-radio-button__inner, .el-radio-button:last-child .el-radio-button__inner {
    border: none;
    display: block;
    width: 100%;
    border-radius: 4px;
    font-size: 14px;
    padding: 0 0 0 10px;
    text-align: left;
    height: 30px;
    line-height: 30px;
    color: #222222;
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #fff;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #222222;
  }
  .container-range {
    .el-checkbox, .el-checkbox__input {
      position: absolute;
      left: 0;
      top: 5px;
    }
    .el-tree-node__expand-icon {
      margin-left: 10px;
    }
  }
  .el-radio-group {
    width: 100%;
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #4A90E2;
  }
  .el-cascader-node.is-active {
    color: #4A90E2;
  }
  .el-cascader-menu:nth-child(3) {
    .el-cascader-node__postfix {
      display: none;
    }
  }
}
/*show-overflow-tooltip隐藏*/
.el-tooltip__popper {
  display: none;
}
.el-popover {
  max-width: 500px;
}
.el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}
.cascader-con {
  height: 100%;
  .el-cascader-menu__wrap {
    height: 100%;
    overflow: inherit;
    overflow-y: scroll;
  }
}
.member{
  .el-checkbox-button__inner{
    border-radius: 20px !important;
  }
  .el-checkbox-button.is-focus .el-checkbox-button__inner{
    border-left: 1px solid #409EFF !important;
  }

}
  .radio-style:hover{
    background: #fff;
    color:  #606266;
  }
  .right-main-con{
    .el-button--primary:hover{
      background: #4A90E2;
      color:  #fff;
    }
  }
  .container-left{
    .el-button--primary:hover{
      background: #4A90E2;
      color:  #fff;
    }
  }
  .container-dashboard .el-table__body .el-button span{
    font-size: 14px;
  }

</style>
